/* global location */
/* global fetch */

import './trial.css';

import React, { Component } from 'react';
import { find } from 'lodash';

import { Link, hashHistory } from 'react-router';
import Icon from '../components/Icon';

import { conditions } from '../services/content';
import { beep } from '../services/audio';
import lang, { selectedLocalization } from '../services/lang';
import FetchPlease from 'fetch-please';
import { API_URI, isIPad } from '../services/config';
const api = new FetchPlease(`${API_URI}/trials/`);
import { trackView } from '../services/analytics';

export default class Trial extends Component {
  state = {
    trial: null,
    isLoading: true,
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    comments: "",
    isEmailing: false,
    isContacting: false,
    showMessage: false,
    notif: "",
    error: "",
  }
  
  componentDidMount() {
    beep();
    
    const id = this.props.params.id;
    
    this.setState({isLoading:true});
    
    api
      .get(id)
      .then(res => {
        this.setState({trial: res.trials[0], isLoading:false});
      });

    trackView("Trial");
  }
  
  componentWillUnmount() {
    api.abort();
    if(this.messageTimeout) {
      clearTimeout(this.messageTimeout);
    }
  }
  
  print() {
    const { trial } = this.state;
    
    fetch(`${API_URI}/print_trial`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      },
      body: JSON.stringify({
        trial: trial.id,
      })
    });
    
    beep();
    
    this.setState({
      showMessage: true,
      message: lang('trial-printed'),
    });
    
    this.messageTimeout = setTimeout(() => this.setState({showMessage:false}), 2000);
  }
  
  handleEmail(e) {
    e.preventDefault();
    const { trial, email } = this.state;
    
    fetch(`${API_URI}/email_trial`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      },
      body: JSON.stringify({
        email,
        language: selectedLocalization,
        trial: trial.id,
      })
    });
    
    beep();
    
    this.setState({
      email: "",
      isEmailing: false,
      showMessage: true,
      message: lang('trial-email-sent'),
    });
    
    this.messageTimeout = setTimeout(() => this.setState({showMessage:false}), 2000);
  }

  scrollToTop = () => {
    console.log('scrolling');
    if(!this.scrollContainer) {
      return;
    }

    this.scrollContainer.scrollTop = 0;
  }
  
  handleContact(e) {
    e.preventDefault();

    const {lastName, firstName, email, phone, comments, trial } = this.state;
    
    if(!firstName) {
      this.setState({showMessage:true, message:"Please enter a first name."});
      return;
    }

    if(!lastName) {
      this.setState({showMessage:true, message:"Please enter a last name."});
      return;
    }

    if(!email) {
      this.setState({showMessage:true, message:"Please enter an email address."});
      return;
    }

    if(!comments) {
      this.setState({showMessage:true, message:"Please enter your comments."});
      return;
    }

    this.setState({showMessage:false});

    fetch(`${API_URI}/contact_trial_coordinator`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      },
      body: JSON.stringify({
        first_name: lastName,
        last_name: firstName,
        email,
        phone,
        comments,
        language: selectedLocalization,
        trial: trial.id,
      })
    });
    
    this.setState({
      lastName: "",
      firstName: "",
      email: "",
      phone: "",
      comments: "",
      isContacting: false,
      showMessage: true,
      message: lang('study-team-contacted'), 
    });
    
    this.messageTimeout = setTimeout(() => this.setState({showMessage:false}), 2000);
  }
  
  handleCancel() {
    this.setState({
      isContacting: false,
      isEmailing: false,
    });
  }
  
  renderRelatedCondition(condition) {
    return (
      <article className="trial-related-trials" key={condition.id}>
        <Link to={`/trials/${condition.id}`}>
          {condition.description}
          <Icon name="arrow" className="trial-aside-icon"/>
        </Link>
        
      </article>
    );
  }
  
  renderTrials() {
    return this.state.trials.map(this.renderTrial);
  }
  
  renderContact(contact) {
    const name = contact.contact.name;
    const phone = contact.contact.phone;
    const address = contact.location.address1;
    const city = contact.location.city;
    const location = (contact.location.name1 || "") + " " + (contact.location.name2 || "");
    const state = contact.location.state;
    const zip = contact.location.zip;
    
    return (
      <div className="trial-aside-contact" key={contact.contact.contactId}>
        <div className="trial-aside-contact-title">{location.trim()}</div>
        <div className="trial-aside-contact-address">{address}</div>
        <div className="trial-aside-contact-city">{city}, {state} {zip}</div>
        <div className="trial-aside-contact-name">{name}</div>
        <div className="trial-aside-contact-phone">{phone}</div>
      </div>
    );
  }

  renderAside() {
    const trial = this.state.trial;

    return (
      <aside className="trial-information">
        <article>
          <h5 className="trial-aside-sectiontitle">Status</h5>
          <ul className="trial-aside-info">
            {trial.phase && 
              <li>
                <Icon name="phase" className="trial-aside-icon"/>
                <span className="trial-aside-status-label">{trial.phase["0"]}</span>
              </li>
            }
            {trial.eligibility && 
              <li>
                <Icon name="user" className="trial-aside-icon"/>
                <span className="trial-aside-status-label">Ages {trial.eligibility["0"].minimum_age} - {trial.eligibility["0"].maximum_age}</span> 
              </li>
            }
          </ul>
        </article>
        
        <article>
          <h5 className="trial-aside-sectiontitle">Explore Related Trials</h5>
          <section>
              {trial.conditions
                .slice(0,3)
                .filter(a => {
                  return !!find(conditions, b => a.id === b.id)
                })
                .map(this.renderRelatedCondition)
              }
          </section>
        </article>
        
        <article>
          <h5 className="trial-aside-sectiontitle">Contact Information</h5>
          
          {trial.publicTrialLocationContactViews.map(this.renderContact.bind(this))}

          <div 
            className="trial-aside-button"
            onClick={() => this.setState({isContacting:false, isEmailing:true}, this.scrollToTop)}>
            Share Trial
          </div>
          <div 
            className="trial-aside-button"
            onClick={() => this.setState({isEmailing:false, isContacting:true}, this.scrollToTop)}>
            Contact Study Team
          </div>
          {!isIPad && 
            <div 
              className="trial-aside-button trial-aside-print"
              onClick={this.print.bind(this)}>
              Print Trial
            </div>
          }

          <Link to="/subscription" 
            className="trial-aside-button">
            New Trial Alerts
          </Link>
          
        </article>
      </aside>
    );
  }
  
  renderSummary() {
    const trial = this.state.trial;
    
    if(!trial.briefSummary.trim()) {
      return null;
    }
    
    return (
      <div>
        <h5 className="trial-summary-sectiontitle">Summary</h5>
        <p className="trial-summary-summary">{trial.briefSummary}</p>
      </div>
    );
  }
  
  renderSponsors() {
    const trial = this.state.trial;
    const sponsors = trial.source.join(", ");
    return (
      <div>
        <h5 className="trial-summary-sectiontitle">Lead Sponsor</h5>
        <p className="trial-summary-sponsors">{sponsors}</p>
      </div>
    );
  }
  
  renderInvestigators() {
    const trial = this.state.trial;
    if(!trial.leadSponsorIsStanford) {
      return;
    }
    
    const investigators = trial.investigators;
    let title = "Stanford Investigator";
    if(investigators.length > 1) {
      title += "s";
    }
    const names = investigators.map(i => i.displayName).join(', ');
    
    return (
      <div>
        <h5 className="trial-summary-sectiontitle">{title}</h5>
        <p className="trial-summary-sponsors">{names}</p>
      </div>
    );
  }
  
  renderInterventions() {
    const trial = this.state.trial;
    const { interventions } = trial;
    if(!interventions || !interventions.length) {
      return;
    }
    
    const list = interventions.map(item => 
      `${item.intervention_type[0]}: ${item.intervention_name[0]}`
    );
    
    return (
      <div>
        <h5 className="trial-summary-sectiontitle">Interventions</h5>
        <ul className="trial-summary-sponsors">
          {list.map((text, i) => {
            return <li key={i}>{text}</li>;
          })}
        </ul>
      </div>
    );
  }
  
  renderEligibility() {
    const trial = this.state.trial;

    if(!trial.eligibility_text) {
      return;
    }
    
    const eligibility = trial.eligibility_text
      .replace(/(?:\r\n|\r|\n)/g, '<br/>')
      .replace("Inclusion Criteria:", "<b>Inclusion Criteria:</b> ")
		  .replace("Exclusion Criteria:", "<b>Exclusion Criteria:</b> ");
		  
		return (
		  <div>
		    <h5 className="trial-summary-sectiontitle">Eligibility</h5>
        <p className="trial-summary-eligiblity" dangerouslySetInnerHTML={{__html:eligibility}}></p>
      </div>
		);
  }
  
  renderInformation() {
    const trial = this.state.trial;
    
    return (
      <article className="trial-summary">
        <h2 className="trial-summary-title">{trial.studyTitle}</h2>
        
        {this.renderSummary()}
        {this.renderSponsors()}
        {this.renderInvestigators()}
        {this.renderInterventions()}
        {this.renderEligibility()}
        
      </article>
    );
  }
  
  renderEmailForm() {
    const trial = this.state.trial;
    const email = this.state.email;
    return (
      <form className="trial-email-form" onSubmit={this.handleEmail.bind(this)}>
        <h2 className="trial-email-title">{trial.studyTitle}</h2>
        <h3 className="trial-email-subtitle">{lang('trial-email')}</h3>
        
        <input 
          type="text" 
          className="trial-email-field"
          placeholder={lang('email')} 
          value={email}
          onChange={e => this.setState({email:e.target.value})}
        />
        
        <div>
          <div className="trial-email-cancel" onClick={this.handleCancel.bind(this)}>{lang('cancel')}</div>
          <button type="submit" className="trial-email-submit">{lang('contact-page-form-submit-button')}</button>
        </div>
        
      </form>
    );
  }
  
  renderContactForm() {
    const trial = this.state.trial;
    const { firstName, lastName, email, phone, comments } = this.state;
    return (
      <form className="trial-contact-form" onSubmit={this.handleContact.bind(this)}>
        <h2 className="trial-contact-title">{trial.studyTitle}</h2>
        <h3 className="trial-contact-subtitle">{lang('trial-contact-instructions')}</h3>
      
        <input 
          type="text" 
          className="trial-contact-field trial-contact-first-name-field"
          placeholder={lang('first-name')} 
          value={firstName}
          onChange={e => this.setState({firstName:e.target.value})}
        />
        <input 
          type="text" 
          className="trial-contact-field trial-contact-last-name-field"
          placeholder={lang('last-name')} 
          value={lastName}
          onChange={e => this.setState({lastName:e.target.value})}
        />
        <input 
          type="text" 
          className="trial-contact-field trial-contact-email-field"
          placeholder={lang('email')} 
          value={email}
          onChange={e => this.setState({email:e.target.value})}
        />
        <input 
          type="text" 
          className="trial-contact-field trial-contact-phone-field"
          placeholder={lang('phone')} 
          value={phone}
          onChange={e => this.setState({phone:e.target.value})}
        />
        <textarea
          className="trial-contact-field trial-contact-message-field"
          placeholder={lang('contact-page-form-phone-textarea-placeholder')} 
          value={comments}
          onChange={e => this.setState({comments:e.target.value})}
        />
        
        <div className="trial-contact-nav">
          <div className="trial-contact-cancel" onClick={this.handleCancel.bind(this)}>{lang('cancel')}</div>
          <button type="submit" className="trial-contact-submit">{lang('contact-page-form-submit-button')}</button>
        </div>
      </form>
    );
  }

  renderContent() {
    const { isEmailing, isContacting } = this.state;
    
    if(isEmailing) {
      return this.renderEmailForm();
    }
    
    if(isContacting) {
      return this.renderContactForm();
    }
    
    return this.renderInformation();
  }
  
  renderMessage() {
    const isActive = !!this.state.showMessage;
    const text = this.state.message || this.state.error || "";
    
    return (
      <div 
        className={`trial-message ${!!isActive ? 'is-active' : ''}`}
        onClick={() => this.setState({showMessage:false})}>
        
        <span className='trial-message-text'>{text}</span>
        
      </div>
    );
  } 
  
  renderMenu() {
    return (
      <div className="trial-menu">
        <div className="trial-menu-back" onClick={hashHistory.goBack}>
          <h5 className="trial-menu-subtitle"> <Icon name="prev" className="trial-menu-back-icon"/> Find Trials</h5>
        </div>
        <Link to="/menu" className="trial-menu-main">
          {lang('main-menu')} <Icon name="menuWhite" className="trial-menu-main-icon"/>
        </Link>
      </div>
    );
  }
  
  renderMobileMenu() {
    return (
      <div className="trial-menu-mobile">
        <div className="trial-menu-back" onClick={hashHistory.goBack}>
          <Icon name="prev" className="trial-menu-back-icon"/>
        </div>
        <h5 className="trial-menu-subtitle">Find Trials</h5>
      </div>
    );
  }
  
  render() {
    const { isLoading } = this.state;
    
    if(isLoading) {
      return (
        <div className="trial">
          <div className="trial-loader">loading</div>
        </div>
      );
    }
    
    return (
      <div className="trial">
        <div className="trial-content-row">
          <div className="trial-content-row-inner" ref={el => this.scrollContainer = el}>
            <div className="trial-content">{this.renderContent()}</div>
            <div className="trial-aside">{this.renderAside()}</div>
          </div>
        </div>
        <div className="trial-menu-row">
          {this.renderMenu()}
          {this.renderMobileMenu()}
        </div>
        {this.renderMessage()}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Trial.js